export default __webpack_public_path__ + "static/ultrasounds-0cdea2c00a7ca01ca869fe035c3138ff.png";